import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { Cell } from '../Cell';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { requestHemexAuction } from '../../../Vehicles/actions';
import { WithVehicleProperty } from '../../../Vehicles/components/WithVehicleProperty';
import { selectVehicle, selectVehicleProperty } from '../../../Vehicles/selectors';

const Container = styled.div``;

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_te_inspecterenComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  get vehicle() {
    return this.props.cell.vehicle;
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={this.vehicle} />
        <WithVehicleProperty propertyValue={this.vehicle.hemex_inspection} doFetch vehicleId={this.props.cell.vehicle.id} propertyName="hemex_inspection">
          {this.props.hemex_inspection === undefined ? (
            <Loader small />
          ) : this.props.hemex_inspection == '2' ? (
            <>
              Is compleet
              <Check />
            </>
          ) : this.props.hemex_inspection == '1' ? (
            'is aangevraagd'
          ) : (
            <Button
              onClick={() => {
                // eslint-disable-next-line no-restricted-globals
                confirm('Veiling aanvragen')
                  ? this.props.requestAuction(result => {
                      // eslint-disable-next-line no-debugger
                      debugger;
                    })
                  : null;
              }}
            >
              Veiling aanvragen
            </Button>
          )}
        </WithVehicleProperty>

        {/* <KanbanExtraCostsWrapper vehicleId={this.vehicle?.id} additionalCosts={HOOI_SCHOONMAKEN_COSTS} /> */}
        <ModalControls>
          <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle?.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_te_inspecterenComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    hemex_inspection: selectVehicleProperty(ownProps.cell.vehicle?.id, 'hemex_inspection'),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    requestAuction(callback) {
      dispatch(requestHemexAuction(ownProps.cell.vehicle?.id, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const HOOI_te_inspecteren = compose(
  withConnect,
  withRouter,
)(HOOI_te_inspecterenComp);
